
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center shadow-lg">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white leading-tight">
                  Strategic
                </h3>
                <p className="text-xs text-blue-400 font-medium tracking-wide">
                  CONSULTING
                </p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              私たちは企業の成長と変革を支援する戦略コンサルティングファームです。
              豊富な経験と専門知識で、お客様のビジネス課題を解決いたします。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-gray-300 hover:text-white cursor-pointer">戦略コンサルティング</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white cursor-pointer">業務改善</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white cursor-pointer">デジタル変革</a></li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white cursor-pointer">組織開発</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span>03-1234-5678</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <span>info@consulting.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>東京都千代田区丸の内1-1-1<br />丸の内ビル10F</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Consulting Company. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
